import type { TOC } from '@ember/component/template-only';
import { eq } from 'tio-ui/utilities';

interface DividerSignature {
  Args: {
    orientation?: 'horizontal' | 'vertical';
  };
  Element: HTMLHRElement | HTMLDivElement;
}

const Divider: TOC<DividerSignature> = <template>
  {{#if (eq @orientation "vertical")}}
    <div
      role="separator"
      aria-orientation="vertical"
      data-test-id="divider"
      class="self-stretch border-0 border-l border-gray-200 dark:border-gray-700"
      ...attributes
    />
  {{else}}
    <hr
      data-test-id="divider"
      class="border-0 border-t border-gray-200 dark:border-gray-700"
      ...attributes
    />
  {{/if}}
</template>;

export default Divider;
